export const CLOSE_BUTTON_ARIA_LABEL = 'quickAdd.modal-close-button-aria-label';
export const OPEN_BUTTON_ARIA_LABEL = 'quickAdd.toggle-open-button-aria-label';
